import { EntityReference } from './basic';

export interface IMedia {
  mediaID: number;
  video?: IVideo;
  language?: string;
  title?: string;
}

export interface IVideo {
  name?: string;
  picture?: IPhotoEntityReference;
  description?: string;
  createdOn?: string;
  source?: number;
  iD: number;
  urlWebm?: string;
  urlOgg?: string;
  urlMp4?: string;
  urlFlv?: string;
  /** The Youtube watch/share URL (only set when source is Youtube) */
  urlYoutube?: string;
}

/** Source of a video, mirrors the backend VideoSource enum */
export enum VideoSource {
  Custom = 0,
  Youtube = 1,
  Cordoba = 2,
  File = 3
}

/** Possible photo sizes */
export enum PhotoSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  Original = 'original'
}

export interface IMediaAndPhotos {
  title: string;
  priority: number;
  media?: IMedia;
  photo?: IPhotoEntityReference;
  clientID?: number;
}

export enum PictureDisplayMode {
  // Teile / object-fit: cover
  Cut = 0,
  // Komplett / object-fit: contain
  Full = 1,
  // Automatisch / currently treated as "Cut"
  Auto = 2
}

/**
 * Interface representing a reference to a photo entity, including various sizes and display options.
 */
export interface IPhotoEntityReference extends EntityReference {
  /** Name of the photo, used for identification or display purposes. */
  name?: string;
  /** Title of the photo, providing additional context or description. */
  title?: string;
  /** Alternative text for the photo, used for accessibility and SEO purposes. */
  alt?: string;
  /** Stretch mode for the photo, defining how it should be displayed within its container. */
  stretchMode?: StretchMode;
  /** Width factor for the photo, used for scaling or resizing calculations. */
  widthFactor: number;
  /** Height factor for the photo, used for scaling or resizing calculations. */
  heightFactor: number;
  /** Small size of the photo, lower resolution version. URL */
  [PhotoSize.Small]: string;
  /** Medium size of the photo, standard resolution version. URL */
  [PhotoSize.Medium]: string;
  /** Large size of the photo, higher resolution version. URL */
  [PhotoSize.Large]: string;
  /**
   * URL to the original photo (2000px bounding box). Optional: the backend emits it only for images
   * rendered full width (hero, titleslider). Consumers must tolerate `undefined`.
   */
  [PhotoSize.Original]?: string;
}

/**
 * Stretch modes for images, defining how they should be resized or displayed within their containers.
 */
export enum StretchMode {
  Exact = 0, // Exakt / TODO: Clarify exact behavior
  Resize = 1, // Vergrößern / TODO: Clarify exact behavior
  ProportionalBiggest = 2, // Proportional (longest edge) / Scale proportionally based on the longest edge
  ProportionalSmallest = 3, // Proportional (shortest edge) / Scale proportionally based on the shortest edge
  Stage = 4, // Bühne / TODO: Clarify exact behavior
  ProportionalExact = 5, // Proportional Exact / TODO: Clarify exact behavior
  ProportionalExactTop = 6, // Proportional Exact (Top) / TODO: Clarify exact behavior
  ProportionalExactBottom = 7, // Proportional Exact (Bottom) / TODO: Clarify exact behavior
  ProportionalExactLeft = 8, // Proportional Exact (Left) / TODO: Clarify exact behavior
  Auto = 9, // Automatically / TODO: Clarify exact behavior
  Original = 10 // Original size / TODO: Clarify exact behavior
}
